import { KuxEventWithParam } from './events';

export class HighFrequencyHeartBeatEventArgs extends KuxEventWithParam {
  /**
   * Total memory available in the device
   */
  // @ts-expect-error TODO Fix
  availableMemory: number;
  /**
   * Total used memory in the device
   */
  // @ts-expect-error TODO Fix
  usedMemory: number;
  /**
   * If connected via WIFI, specify the WIFI signal strength (in dBm). Empty if unknown
   */
  // @ts-expect-error TODO Fix
  wifiSignal: number;
  /**
   * If connected via WIF, WIFI signal frequency
   */
  // @ts-expect-error TODO Fix
  wifiFrequency: '2.4' | '5' | 'OTHER';
  /**
   * If connected via WIFI, specify the WIFI SSID
   */
  // @ts-expect-error TODO Fix
  wifiSsid: string;

  constructor(data: HighFrequencyHeartBeatEventArgs) {
    super('highFrequencyHeartbeat', data as KuxEventWithParam);
    Object.assign(this, data);
  }
}
